var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartOutline = function SvgCartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M8.674 12.99a1.222 1.222 0 1 1-2.443 0 1.222 1.222 0 0 1 2.443 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M8.567 12.991a1.115 1.115 0 1 0-1.114 1.114v.107l-.125-.005a1.22 1.22 0 0 1-1.09-1.091l-.007-.125c0-.675.547-1.222 1.222-1.222l.125.007a1.22 1.22 0 0 1 1.096 1.215l-.005.125a1.223 1.223 0 0 1-1.216 1.096v-.107c.615 0 1.114-.499 1.114-1.114M15.957 12.99a1.222 1.222 0 1 1-2.444 0 1.222 1.222 0 0 1 2.444 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M15.85 12.991a1.115 1.115 0 1 0-1.114 1.114l-.001.107-.125-.005a1.22 1.22 0 0 1-1.09-1.091l-.007-.125c0-.675.547-1.222 1.222-1.222l.125.007a1.22 1.22 0 0 1 1.097 1.215l-.006.125a1.223 1.223 0 0 1-1.216 1.096v-.107c.615 0 1.114-.499 1.114-1.114M3.217 0c.342 0 .642.224.74.551l.569 1.892h12.7a.774.774 0 0 1 .757.937L16.58 9.895a.775.775 0 0 1-.756.612H6.068a.775.775 0 0 1-.736-.535L3.215 3.457l-.006-.017-.567-1.893H.774A.774.774 0 1 1 .774 0zM6.63 8.96h8.568l1.07-4.97H5.014z"
  })));
};
export default SvgCartOutline;